import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-legal-dialog',
    templateUrl: './legal-dialog.component.html',
    styleUrls: ['./legal-dialog.component.css'],
})
export class LegalDialogComponent {
    constructor(public dialogRef: MatDialogRef<LegalDialogComponent>) {}
    onNoClick(): void {
        this.dialogRef.close();
    }
}
